import { generateURL } from './url.util';

import { LOCAL_STORAGE_KEY } from 'shared/infra/constants/local-storage.const';

import type { GenerateURLParams } from './url.util';

export function generateURLRappiServices(
  params: Omit<GenerateURLParams, 'base'>,
) {
  return generateURL({
    ...params,
    base: window.localStorage.getItem(LOCAL_STORAGE_KEY.country.services) ?? '',
  });
}
